import { Component, OnInit } from '@angular/core';
import { ApiService } from "../../api.service";

@Component({
  selector: 'app-edit-emp',
  templateUrl: './edit-emp.page.html',
  styleUrls: ['./edit-emp.page.scss'],
})
export class EditEmpPage implements OnInit {

  constructor(
    public api:ApiService
  ) { }

  ngOnInit() {
  }

}
